var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactSurveyElement, SurveyElementBase, SurveyQuestionElementBase, } from "./reactquestion_element";
import { SurveyQuestion, SurveyQuestionAndErrorsCell, SurveyQuestionErrorCell } from "./reactquestion";
import { SurveyQuestionCheckboxItem } from "./reactquestion_checkbox";
import { SurveyQuestionRadioItem } from "./reactquestion_radiogroup";
import { SurveyPanel } from "./panel";
import { SurveyActionBar } from "./components/action-bar/action-bar";
import { MatrixRow } from "./components/matrix/row";
import { SurveyQuestionMatrixDynamicDragDropIcon } from "./components/matrix-actions/drag-drop-icon/drag-drop-icon";
import { SurveyQuestionCommentValueItem } from "./reactquestion_comment";
import { ReactElementFactory } from "./element-factory";
var SurveyQuestionMatrixTable = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixTable, _super);
    function SurveyQuestionMatrixTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyQuestionMatrixTable.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionMatrixTable.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionMatrixTable.prototype, "table", {
        get: function () {
            return this.question.renderedTable;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrixTable.prototype.getStateElement = function () {
        return this.table;
    };
    SurveyQuestionMatrixTable.prototype.wrapCell = function (cell, element, reason) {
        return this.props.wrapCell(cell, element, reason);
    };
    SurveyQuestionMatrixTable.prototype.renderHeader = function () {
        var table = this.question.renderedTable;
        if (!table.showHeader)
            return null;
        var headers = [];
        var cells = table.headerRow.cells;
        for (var i = 0; i < cells.length; i++) {
            var cell = cells[i];
            var key = "column" + i;
            var columnStyle = {};
            if (!!cell.width) {
                columnStyle.width = cell.width;
            }
            if (!!cell.minWidth) {
                columnStyle.minWidth = cell.minWidth;
            }
            var cellContent = this.renderCellContent(cell, "column-header", {});
            var header = cell.hasTitle ?
                React.createElement("th", { className: cell.className, key: key, style: columnStyle },
                    " ",
                    cellContent,
                    " ")
                : React.createElement("td", { className: cell.className, key: key, style: columnStyle });
            headers.push(header);
        }
        return (React.createElement("thead", null,
            React.createElement("tr", null, headers)));
    };
    SurveyQuestionMatrixTable.prototype.renderFooter = function () {
        var table = this.question.renderedTable;
        if (!table.showFooter)
            return null;
        var row = this.renderRow("footer", table.footerRow, this.question.cssClasses, "row-footer");
        return React.createElement("tfoot", null, row);
    };
    SurveyQuestionMatrixTable.prototype.renderRows = function () {
        var cssClasses = this.question.cssClasses;
        var rows = [];
        var renderedRows = this.question.renderedTable.renderedRows;
        for (var i = 0; i < renderedRows.length; i++) {
            rows.push(this.renderRow(renderedRows[i].id, renderedRows[i], cssClasses));
        }
        return React.createElement("tbody", null, rows);
    };
    SurveyQuestionMatrixTable.prototype.renderRow = function (keyValue, row, cssClasses, reason) {
        var matrixrow = [];
        var cells = row.cells;
        for (var i = 0; i < cells.length; i++) {
            matrixrow.push(this.renderCell(cells[i], cssClasses, reason));
        }
        var key = "row" + keyValue;
        return (React.createElement(React.Fragment, { key: key }, (reason == "row-footer") ? React.createElement("tr", null, matrixrow) : React.createElement(MatrixRow, { model: row, parentMatrix: this.question }, matrixrow)));
    };
    SurveyQuestionMatrixTable.prototype.renderCell = function (cell, cssClasses, reason) {
        var key = "cell" + cell.id;
        if (cell.hasQuestion) {
            return (React.createElement(SurveyQuestionMatrixDropdownCell, { key: key, cssClasses: cssClasses, cell: cell, creator: this.creator, reason: reason }));
        }
        if (cell.isErrorsCell) {
            if (cell.isErrorsCell) {
                return (React.createElement(SurveyQuestionMatrixDropdownErrorsCell, { cell: cell, key: key, keyValue: key, question: cell.question, creator: this.creator }));
            }
        }
        var calcReason = reason;
        if (!calcReason) {
            calcReason = cell.hasTitle ? "row-header" : "";
        }
        var cellContent = this.renderCellContent(cell, calcReason, cssClasses);
        var cellStyle = null;
        if (!!cell.width || !!cell.minWidth) {
            cellStyle = {};
            if (!!cell.width)
                cellStyle.width = cell.width;
            if (!!cell.minWidth)
                cellStyle.minWidth = cell.minWidth;
        }
        return (React.createElement("td", { className: cell.className, key: key, style: cellStyle, colSpan: cell.colSpans, title: cell.getTitle() }, cellContent));
    };
    SurveyQuestionMatrixTable.prototype.renderCellContent = function (cell, reason, cssClasses) {
        var cellContent = null;
        var cellStyle = null;
        if (!!cell.width || !!cell.minWidth) {
            cellStyle = {};
            if (!!cell.width)
                cellStyle.width = cell.width;
            if (!!cell.minWidth)
                cellStyle.minWidth = cell.minWidth;
        }
        if (cell.hasTitle) {
            reason = "row-header";
            var str = this.renderLocString(cell.locTitle);
            var require_1 = !!cell.column ? React.createElement(SurveyQuestionMatrixHeaderRequired, { column: cell.column, question: this.question }) : null;
            cellContent = (React.createElement(React.Fragment, null,
                str,
                require_1));
        }
        if (cell.isDragHandlerCell) {
            cellContent = (React.createElement(React.Fragment, null,
                React.createElement(SurveyQuestionMatrixDynamicDragDropIcon, { item: { data: { row: cell.row, question: this.question } } })));
        }
        if (cell.isActionsCell) {
            cellContent = (ReactElementFactory.Instance.createElement("sv-matrixdynamic-actions-cell", {
                question: this.question,
                cssClasses: cssClasses,
                cell: cell,
                model: cell.item.getData()
            }));
        }
        if (cell.hasPanel) {
            cellContent = (React.createElement(SurveyPanel, { key: cell.panel.id, element: cell.panel, survey: this.question.survey, cssClasses: cssClasses, isDisplayMode: this.isDisplayMode, creator: this.creator }));
        }
        if (!cellContent)
            return null;
        var readyCell = (React.createElement(React.Fragment, null, cellContent));
        return this.wrapCell(cell, readyCell, reason);
    };
    SurveyQuestionMatrixTable.prototype.renderElement = function () {
        var header = this.renderHeader();
        var footers = this.renderFooter();
        var rows = this.renderRows();
        return (React.createElement("table", { className: this.question.getTableCss() },
            header,
            rows,
            footers));
    };
    return SurveyQuestionMatrixTable;
}(SurveyElementBase));
var SurveyQuestionMatrixDropdownBase = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixDropdownBase, _super);
    function SurveyQuestionMatrixDropdownBase(props) {
        var _this = _super.call(this, props) || this;
        //Create rendered table in contructor and not on rendering
        var table = _this.question.renderedTable;
        _this.state = _this.getState();
        return _this;
    }
    Object.defineProperty(SurveyQuestionMatrixDropdownBase.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrixDropdownBase.prototype.getState = function (prevState) {
        if (prevState === void 0) { prevState = null; }
        return { rowCounter: !prevState ? 0 : prevState.rowCounter + 1 };
    };
    SurveyQuestionMatrixDropdownBase.prototype.updateStateOnCallback = function () {
        if (this.isRendering)
            return;
        this.setState(this.getState(this.state));
    };
    SurveyQuestionMatrixDropdownBase.prototype.componentDidMount = function () {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        this.question.onRenderedTableResetCallback = function () {
            _this.updateStateOnCallback();
        };
    };
    SurveyQuestionMatrixDropdownBase.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.question.onRenderedTableResetCallback = function () { };
    };
    SurveyQuestionMatrixDropdownBase.prototype.renderElement = function () {
        return this.renderTableDiv();
    };
    SurveyQuestionMatrixDropdownBase.prototype.renderTableDiv = function () {
        var _this = this;
        return (React.createElement("div", { className: this.question.getTableWrapperCss(), ref: function (root) { return (_this.setControl(root)); } },
            React.createElement(SurveyQuestionMatrixTable, { question: this.question, creator: this.creator, wrapCell: function (cell, element, reason) { return _this.wrapCell(cell, element, reason); } })));
    };
    return SurveyQuestionMatrixDropdownBase;
}(SurveyQuestionElementBase));
export { SurveyQuestionMatrixDropdownBase };
var SurveyQuestionMatrixActionsCell = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixActionsCell, _super);
    function SurveyQuestionMatrixActionsCell(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionMatrixActionsCell.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrixActionsCell.prototype.renderElement = function () {
        return (React.createElement(SurveyActionBar, { model: this.model, handleClick: false }));
    };
    return SurveyQuestionMatrixActionsCell;
}(ReactSurveyElement));
var SurveyQuestionMatrixDropdownErrorsCell = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixDropdownErrorsCell, _super);
    function SurveyQuestionMatrixDropdownErrorsCell(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionMatrixDropdownErrorsCell.prototype, "key", {
        get: function () {
            return this.props.keyValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionMatrixDropdownErrorsCell.prototype, "cell", {
        get: function () {
            return this.props.cell;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrixDropdownErrorsCell.prototype.render = function () {
        if (!this.cell.isVisible)
            return null;
        return React.createElement("td", { className: this.cell.className, key: this.key, colSpan: this.cell.colSpans, title: this.cell.getTitle() }, _super.prototype.render.call(this));
    };
    SurveyQuestionMatrixDropdownErrorsCell.prototype.getQuestionPropertiesToTrack = function () {
        return _super.prototype.getQuestionPropertiesToTrack.call(this).concat(["visible"]);
    };
    return SurveyQuestionMatrixDropdownErrorsCell;
}(SurveyQuestionErrorCell));
ReactElementFactory.Instance.registerElement("sv-matrixdynamic-actions-cell", function (props) {
    return React.createElement(SurveyQuestionMatrixActionsCell, props);
});
var SurveyQuestionMatrixHeaderRequired = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixHeaderRequired, _super);
    function SurveyQuestionMatrixHeaderRequired(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionMatrixHeaderRequired.prototype, "column", {
        get: function () {
            return this.props.column;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionMatrixHeaderRequired.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrixHeaderRequired.prototype.getStateElement = function () {
        return this.column;
    };
    SurveyQuestionMatrixHeaderRequired.prototype.renderElement = function () {
        if (!this.column.isRenderedRequired)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement("span", null, "\u00A0"),
            React.createElement("span", { className: this.question.cssClasses.cellRequiredMark }, this.column.requiredMark)));
    };
    return SurveyQuestionMatrixHeaderRequired;
}(ReactSurveyElement));
var SurveyQuestionMatrixDropdownCell = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixDropdownCell, _super);
    function SurveyQuestionMatrixDropdownCell(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionMatrixDropdownCell.prototype, "cell", {
        get: function () {
            return this.props.cell;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionMatrixDropdownCell.prototype, "itemCss", {
        get: function () {
            return !!this.cell ? this.cell.className : "";
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrixDropdownCell.prototype.getQuestion = function () {
        var q = _super.prototype.getQuestion.call(this);
        if (!!q)
            return q;
        return !!this.cell ? this.cell.question : null;
    };
    SurveyQuestionMatrixDropdownCell.prototype.doAfterRender = function () {
        var el = this.cellRef.current;
        if (el &&
            this.cell &&
            this.question &&
            this.question.survey &&
            el.getAttribute("data-rendered") !== "r") {
            el.setAttribute("data-rendered", "r");
            var options = {
                cell: this.cell,
                cellQuestion: this.question,
                htmlElement: el,
                row: this.cell.row,
                column: this.cell.cell.column,
            };
            this.question.survey.matrixAfterCellRender(options);
            this.question.afterRenderCore(el);
        }
    };
    SurveyQuestionMatrixDropdownCell.prototype.getShowErrors = function () {
        return (this.question.isVisible &&
            (!this.cell.isChoice || this.cell.isFirstChoice));
    };
    SurveyQuestionMatrixDropdownCell.prototype.getCellStyle = function () {
        var res = _super.prototype.getCellStyle.call(this);
        if (!!this.cell.width || !!this.cell.minWidth) {
            if (!res)
                res = {};
            if (!!this.cell.width)
                res.width = this.cell.width;
            if (!!this.cell.minWidth)
                res.minWidth = this.cell.minWidth;
        }
        return res;
    };
    SurveyQuestionMatrixDropdownCell.prototype.getHeaderText = function () {
        return this.cell.headers;
    };
    SurveyQuestionMatrixDropdownCell.prototype.renderElement = function () {
        if (!this.cell.isVisible) {
            return null;
        }
        return _super.prototype.renderElement.call(this);
    };
    SurveyQuestionMatrixDropdownCell.prototype.renderCellContent = function () {
        var content = _super.prototype.renderCellContent.call(this);
        var responsiveTitle = this.cell.showResponsiveTitle ? (React.createElement("span", { className: this.cell.responsiveTitleCss },
            this.renderLocString(this.cell.responsiveLocTitle),
            React.createElement(SurveyQuestionMatrixHeaderRequired, { column: this.cell.column, question: this.cell.matrix }))) : null;
        return React.createElement(React.Fragment, null,
            responsiveTitle,
            content);
    };
    SurveyQuestionMatrixDropdownCell.prototype.renderQuestion = function () {
        if (!this.question.isVisible)
            return React.createElement(React.Fragment, null);
        if (!this.cell.isChoice)
            return SurveyQuestion.renderQuestionBody(this.creator, this.question);
        if (this.cell.isOtherChoice)
            return this.renderOtherComment();
        if (this.cell.isCheckbox)
            return this.renderCellCheckboxButton();
        return this.renderCellRadiogroupButton();
    };
    SurveyQuestionMatrixDropdownCell.prototype.renderOtherComment = function () {
        var question = this.cell.question;
        var cssClasses = question.cssClasses || {};
        return React.createElement(SurveyQuestionCommentValueItem, { question: question, item: question.otherItem, cssClasses: cssClasses });
    };
    SurveyQuestionMatrixDropdownCell.prototype.renderCellCheckboxButton = function () {
        var key = this.cell.question.id + "item" + this.cell.choiceIndex;
        return (React.createElement(SurveyQuestionCheckboxItem, { key: key, question: this.cell.question, cssClasses: this.cell.question.cssClasses, isDisplayMode: this.cell.question.isInputReadOnly, item: this.cell.item, isFirst: this.cell.isFirstChoice, index: this.cell.choiceIndex.toString(), hideCaption: true, ariaLabel: this.getCellAriaLabel() }));
    };
    SurveyQuestionMatrixDropdownCell.prototype.renderCellRadiogroupButton = function () {
        var key = this.cell.question.id + "item" + this.cell.choiceIndex;
        return (React.createElement(SurveyQuestionRadioItem, { key: key, question: this.cell.question, cssClasses: this.cell.question.cssClasses, isDisplayMode: this.cell.question.isInputReadOnly, item: this.cell.item, index: this.cell.choiceIndex.toString(), isChecked: this.cell.question.value === this.cell.item.value, isDisabled: this.cell.question.isReadOnly || !this.cell.item.isEnabled, hideCaption: true, ariaLabel: this.getCellAriaLabel() }));
    };
    SurveyQuestionMatrixDropdownCell.prototype.getCellAriaLabel = function () {
        return this.question.parentQuestion.getCellAriaLabel(this.cell.row, this.cell.column);
    };
    return SurveyQuestionMatrixDropdownCell;
}(SurveyQuestionAndErrorsCell));
export { SurveyQuestionMatrixDropdownCell };
